import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M20.956 11.4C19.68 7.68 16.156 5.001 12 5.001s-7.682 2.677-8.957 6.397a.75.75 0 0 0-.001.487c1.275 3.72 4.802 6.398 8.958 6.398s7.682-2.677 8.957-6.398a.75.75 0 0 0-.001-.487m-16.406.242a7.97 7.97 0 0 1 7.124-5.133L12 6.502a7.97 7.97 0 0 1 7.448 5.14 7.967 7.967 0 0 1-14.898 0m7.44-2.229a2.23 2.23 0 0 0 0 4.46h.017a2.23 2.23 0 1 0 0-4.46z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }